<!-- <div class="select-wallet">

    <div class="wallets" #walletsView (resized)="onResized($event)">
        <div [class]="'selected wallet ' + walletClass">
            <div class="wallet-header">
                <div class="currency">{{selectedWallet.currencyCode}}</div>
                <div class="number">{{selectedWallet.accountNumber}}</div>
                <i class="icon-check-circle"></i>
            </div>
            <div class="wallet-content">
                <span> {{selectedWallet.balance}} </span>
            </div>
        </div>

    </div>
</div> -->

<div class="wallet-container" #wallets (resized)="onResized($event)">
    <div [class]="'wallet selected-wallet selectable selected ' + walletClass">
        <div class="wallet-content">
            <div class="icon-check-circle"></div>
            <div class="detail">
                <div class="wallet-icon">
                    <i class="icon-wallet-vt"></i>
                </div>
                <div class="info">
                    <div class="type">{{selectedWallet.walletName}}</div>
                    <div class="number">{{selectedWallet.accountNumber}}</div>
                </div>
            </div>
            <div class="amount">
                <div class="number">{{selectedWallet.balance}} </div>
                <div class="currency">{{selectedWallet.currencyCode}}</div>
            </div>
        </div>
    </div>

</div>